import positionBlogContents from "./positionBlogContents";
import {checkIfAlreadyProsted} from "../../prost/checkIfAlreadyProsted";
import {checkIfAlreadyFavourites} from "../../favourites/checkIfAlreadyFavourites";
export function loadBlogContent(ids, furtherParams, shopUserId, lazyLoadOnThisPage) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=load_blog_entries",
        datatype: "json",
        data: {
            "ajax_call_ids": ids,
            "ajax_call_list_community_type": communityType
        },
        success: function (output) {
            positionBlogContents(output, lazyLoadOnThisPage);
            checkIfAlreadyProsted(ids, "", shopUserId, false, 5);
            checkIfAlreadyFavourites(ids, shopUserId, 5);
        }
    });
}